<template>
  <div class="checkout-container" v-show="readyCheckout">
    <div id="checkout"></div>
    <div>
      <p @click="hideCheckoutModal" class="a">
        <span><i class="fas fa-chevron-left"></i>確認画面へもどる</span>
      </p>
    </div>
  </div>
</template>

<script>
export default {
  name: 'checkout',
  props: ['step', 'reservation', 'readyCheckout'],
  data() {
    return {}
  },
  computed: {
    paymentMethod() {
      return this.reservation.customer.payment_method
    }
  },
  async mounted() {
    let modalCartBtn = document.getElementById('pageHeaderCartBtn')
    modalCartBtn.style.display = 'none'
    // await this.createCheckoutUI()
  },

  methods: {
    hideCheckoutModal() {
      this.$emit('hideCheckoutModal')
    },
    createCheckoutUI() {
      this.$emit('createCheckoutUI')
      this.$emit('smoothScroll')
    },
    prev: function (number) {
      this.$emit('prev', number)
    }
  }
}
</script>

<style lang="scss">
.checkout-container {
  #checkout {
    border-radius: 13px;
    width: 412px;
    overflow: hidden;
    margin: auto;
    background-color: white;
  }

  .a {
    color: #000;
    display: block;
    text-align: center;
    margin-top: 15px;
    i {
      margin-right: 5px;
    }
    span {
      border-bottom: 1px #000 solid;
      &:hover {
        opacity: 0.7;
        cursor: pointer;
      }
    }
  }

  // .checkout-wrapper {
  //   padding: 4rem;
  // }

  .back-to-confirm {
    position: absolute;
    top: 1rem;
    right: 1rem;
    width: 24px;
    height: 24px;
    background-color: #000;
  }
}
</style>
